export const validatePageNumber = (page: number, pageCount: number): boolean => {
  if (page && !(page <= 0) && !(page > pageCount)) {
    return true
  }

  return false
}
